import actionTypes from './actionTypes'

const generalActions = {
	openModal(modalName, params = {}) {
		return {
			type: actionTypes.OPEN_MODAL,
			modalName,
			params,
		}
	},
	closeModal(modalName) {
		return {
			type: actionTypes.CLOSE_MODAL,
			modalName,
		}
	},
	openMessage(messageObject, type) {
		switch (type) {
			case 'alert':
				type = actionTypes.OPEN_ALERT
				break
			case 'centerInformation':
				type = actionTypes.OPEN_CENTER_INFORMATION
				break
			case 'topInformation':
				type = actionTypes.OPEN_TOP_INFORMATION
				break
		}
		return {
			type,
			messageObject,
		}
	},
	closeMessage(uid, type) {
		switch (type) {
			case 'alert':
				type = actionTypes.CLOSE_ALERT
				break
			case 'centerInformation':
				type = actionTypes.CLOSE_CENTER_INFORMATION
				break
			case 'topInformation':
				type = actionTypes.CLOSE_TOP_INFORMATION
				break
		}
		return {
			type,
			uid,
		}
	},
	changeTab(selectedTab, type) {
		switch (type) {
			case 'main_share':
				type = actionTypes.SHARE_CHANGE_MAIN_TAB
				break
			case 'embed_share':
				type = actionTypes.SHARE_CHANGE_EMBED_TAB
				break
			case 'signup':
				switch (selectedTab) {
					case 'student':
						type = actionTypes.SIGNUP_CHANGE_TAB_STUDENT
						break
					case 'teacher':
						type = actionTypes.SIGNUP_CHANGE_TAB_TEACHER
						break
				}
				break
		}
		return {
			type,
			selectedTab,
		}
	},
	hasLibraryLoad(libraryName, state) {
		return {
			type: actionTypes.LIBRARY_LOAD,
			libraryName,
			state,
		}
	},
	tryAutoLogin() {
		return {
			type: actionTypes.AUTO_LOGIN,
		}
	},
	closeConfirm(confirmType) {
		return {
			type: actionTypes.CLOSE_CONFIRM,
			confirmType,
		}
	},
	dismissRedirection(confirmType) {
		return {
			type: actionTypes.DISMISS_REDIRECTION,
			confirmType,
		}
	},
	toggleSidebar() {
		return {
			type: actionTypes.TOGGLE_SIDEBAR,
		}
	},
	mediaPreview(mediaType, mediaVersions) {
		return {
			type: actionTypes.MEDIA_PREVIEW,
			mediaType,
			mediaVersions,
		}
	},
	windowResize(width, height) {
		return {
			type: actionTypes.UI_WINDOW_RESIZE,
			width,
			height,
		}
	},
	appInitialize(width, height, platform, isInIframe) {
		return {
			type: actionTypes.APP_INITIALIZE,
			width,
			height,
			platform,
			isInIframe,
		}
	},
	syncUncaughtError(error) {
		return {
			type: actionTypes.SYNC_UNCAUGHT_ERROR,
			error,
		}
	},
	getLessonMetricsError(error) {
		return {
			type: actionTypes.METRICS_GET_LESSON_ERROR,
			error,
		}
	},
}

export default generalActions
